import { useState, useEffect, useCallback } from 'react';
import { getInvoiceDraftList, TGetPaymentBillingList } from 'api/provider';
import { getGPInvoiceDraftList } from 'api/group';
import { TPaymentBilling } from 'types/provider';

const useInvoiceDraftList = (
    param?: Partial<TGetPaymentBillingList>,
    isPracticeView?: boolean,
): [
    TPaymentBilling[] | undefined,
    number,
    boolean,
    (param?: Partial<TGetPaymentBillingList>) => void,
] => {
    const [data, setData] = useState<TPaymentBilling[]>();
    const [total, setTotal] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);

    const fetchData = async (para: Partial<TGetPaymentBillingList> = {}) => {
        try {
            setLoading(true);
            const res = isPracticeView
                ? await getGPInvoiceDraftList({ current: 1, size: 10, ...para })
                : await getInvoiceDraftList({ current: 1, size: 10, ...para });
            if (!res.error) {
                const list = res.data?.data?.records || [];
                const amount = res.data?.data?.total;
                setTotal(amount || 0);
                setData(list);
            }
        } catch (err) {
            console.error('Payment list fetch error:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(param);
    }, []);

    return [data, total, loading, fetchData];
};

export default useInvoiceDraftList;
